export default __webpack_public_path__ + "static/media/close.c0708ad9.svg";